import * as actions from '../../actions/actionTypes';
import initialState from '../initialState';

/**
 * This reducer handles the LOAD_SECURITY_MASTER_DATA_SUCCESS & LOAD_SECURITY_MASTER_DATA_FAILURE action
 * and sets the security management data to the store
 * @param {Object} [state] The master data management security grid data
 * @param {Object} action The action to be handled
 * @returns {Object} The master data management security grid data
 */

export default function masterDataManagementSecurityReducers(
  state = initialState.securityMasterData,
  action
) {
  if (
    action.type === actions.LOAD_SECURITY_MASTER_DATA_SUCCESS &&
    Array.isArray(action.securityMasterData)
  ) {
    return action.securityMasterData;
  } else if (action.type === actions.LOAD_SECURITY_MASTER_DATA_FAILURE) {
    return initialState.securityMasterData;
  } else {
    return state;
  }
}
